import { updatePersonalDataPathFromCheckout } from 'app/services/businessFunctions/helpers/updatePersonalDataPathFromCheckout';

const onCheckoutOwnerLastNameChange = {
  onCheckoutOwnerLastNameChange() {
    updatePersonalDataPathFromCheckout();
  },
};

export default onCheckoutOwnerLastNameChange;
